import { useEffect } from 'react';
import { toast } from 'react-toastify';

import { AccessRequestClientModel, useRevokeAccessRequest } from '@apono/client-app-sdk';

import InvalidateAction from '@common/components/InvalidateAction';

export default function RevokeRequest({ request }: { request: AccessRequestClientModel }) {
  const { revokeAccessRequest, isLoading, isSuccess } = useRevokeAccessRequest(request.id);

  useEffect(() => {
    if (isSuccess) {
      toast.success(`Request ${request.id} revoked`);
    }
  }, [isSuccess, request.id]);

  return (
    <InvalidateAction
      loading={isLoading}
      buttonText="Revoke access"
      confirmText={`Are you sure you want to revoke ${request.id} access request?`}
      invalidateAction={revokeAccessRequest}
    />
  );
}
